module.exports = {"310104003":"天平路街道","310104004":"湖南路街道","310104007":"斜土路街道","310104008":"枫林路街道","310104010":"长桥街道","310104011":"田林街道","310104012":"虹梅路街道","310104013":"康健新村街道","310104014":"徐家汇街道","310104015":"凌云路街道","310104016":"龙华街道","310104017":"漕河泾街道","310104103":"华泾镇","310104501":"漕河泾新兴技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310104.json
// module id = 810
// module chunks = 0